import { render, staticRenderFns } from "./PowerSettingBlock.vue?vue&type=template&id=72d2c7a7&"
import script from "./PowerSettingBlock.vue?vue&type=script&lang=js&"
export * from "./PowerSettingBlock.vue?vue&type=script&lang=js&"
import style0 from "./PowerSettingBlock.vue?vue&type=style&index=0&id=72d2c7a7&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports